import { render, staticRenderFns } from "./PickTopic.vue?vue&type=template&id=583d7ce9&"
import script from "./PickTopic.vue?vue&type=script&lang=js&"
export * from "./PickTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports